var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('detail',{attrs:{"on-manager":_vm.onManager,"data":_vm.data,"base-info":_vm.baseInfo,"extra-info":_vm.extraInfo}})}
var staticRenderFns = []

export { render, staticRenderFns }